import { render, staticRenderFns } from "./MulticastForm.vue?vue&type=template&id=82bb9552&scoped=true"
import script from "./MulticastForm.vue?vue&type=script&lang=js"
export * from "./MulticastForm.vue?vue&type=script&lang=js"
import style0 from "./MulticastForm.vue?vue&type=style&index=0&id=82bb9552&prod&lang=less&scoped=true"
import style1 from "./MulticastForm.vue?vue&type=style&index=1&id=82bb9552&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bb9552",
  null
  
)

export default component.exports